import React from 'react';
import { Link } from 'react-router-dom';
import TopBarSidebarButton from './TopbarSidebarButton';
import TopBarProfile from './TopbarProfile';
import TopbarNotification from './TopbarNotification';

export default function Topbar() {
    return (
        <div className="topbar">
            <div className="topbar__wrapper">
                <TopBarSidebarButton />
                <Link className="topbar__logo" to="/Leads/Manage" />
                <div className="topbar__right">
                    <TopbarNotification />
                    <TopBarProfile />
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/modules/App/components/topbar/Topbar.js